const map = {
	"./app/messages/en-US.ts": 20442,
	"./app/messages/pt-BR.ts": 15763,
	"./app/store.ts": 76130,
	"./auth/messages/en-US.ts": 33909,
	"./auth/messages/pt-BR.ts": 78252,
	"./auth/routes.ts": 49230,
	"./auth/store.ts": 92119,
	"./auth/tables.ts": 7685,
	"./auth/types.ts": 70163,
	"./doc/messages/en-US.ts": 48065,
	"./doc/messages/pt-BR.ts": 29768,
	"./doc/tables.ts": 98209,
	"./doc/types.ts": 73279,
	"./flp/messages/en-US.ts": 98317,
	"./flp/messages/pt-BR.ts": 71380,
	"./flp/tables.ts": 20685,
	"./infra/messages/en-US.ts": 47189,
	"./infra/messages/pt-BR.ts": 28940,
	"./infra/tables.ts": 15749,
	"./payment/messages/en-US.ts": 8437,
	"./payment/messages/pt-BR.ts": 90188,
	"./payment/tables.ts": 28677
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86981;